import { useState, useRef } from "react";
import { ChevronLeft, ChevronRight, Play } from "lucide-react";

const SNEAKERS_IMAGE = "https://customer-assets-rejwkqb3.emergentagent.net/job_2865d04f-1753-4ac2-b4d4-74d332d7faa7/artifacts/a350d318a612025c_6C60FD38-4373-4FCE-BFFB-D4883A01ABDB.PNG";
const SLIDES = 2;

export const SneakersCarousel = () => {
  const [index, setIndex] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const videoRef = useRef(null);

  const goTo = (i) => {
    const next = (i + SLIDES) % SLIDES;
    if (next !== 1) videoRef.current?.pause();
    setIndex(next);
  };

  const onTouchEnd = (e) => {
    if (touchStart === null) return;
    const dist = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(dist) > 50) goTo(index + (dist > 0 ? 1 : -1));
    setTouchStart(null);
  };

  const arrow = "absolute top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 hover:bg-white rounded-full shadow-lg flex items-center justify-center z-10";

  return (
    <section className="pb-4 px-4" data-testid="sneakers-carousel">
      <div className="max-w-4xl mx-auto">
        <div className="relative rounded-2xl overflow-hidden shadow-xl bg-black"
          onTouchStart={(e) => setTouchStart(e.touches[0].clientX)} onTouchEnd={onTouchEnd}>
          <div className="flex transition-transform duration-300 ease-in-out" style={{ transform: `translateX(-${index * 100}%)` }}>
            <div className="w-full flex-shrink-0 bg-white">
              <img src={SNEAKERS_IMAGE} alt="Nouveau : nettoyage de vos sneakers pour seulement 19€" className="w-full h-auto" draggable={false} data-testid="sneakers-image" />
            </div>
            <div className="w-full flex-shrink-0 flex items-center">
              <video ref={videoRef} src="/sneakers-video-v2.mp4" controls playsInline preload="metadata" className="w-full h-auto" data-testid="sneakers-video" />
            </div>
          </div>
          {index === 0 && (
            <button onClick={() => goTo(1)} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex items-center gap-2 bg-pink-600 text-white text-sm font-semibold px-4 py-2 rounded-full shadow-lg animate-pulse" data-testid="sneakers-see-video-btn">
              <Play className="w-4 h-4" /> Voir la vidéo
            </button>
          )}
          <button onClick={() => goTo(index - 1)} className={`${arrow} left-2`} aria-label="Précédent" data-testid="sneakers-prev-btn"><ChevronLeft className="w-6 h-6 text-pink-600" /></button>
          <button onClick={() => goTo(index + 1)} className={`${arrow} right-2`} aria-label="Suivant" data-testid="sneakers-next-btn"><ChevronRight className="w-6 h-6 text-pink-600" /></button>
          <div className={`absolute ${index === 1 ? "top-3" : "bottom-4"} left-1/2 -translate-x-1/2 flex gap-2`}>
            {[0, 1].map((i) => (
              <button key={i} onClick={() => goTo(i)} className={`w-3 h-3 rounded-full ${index === i ? "bg-pink-600 scale-110" : "bg-white/70"}`} aria-label={i ? "Vidéo" : "Image"} data-testid={`sneakers-dot-${i}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
